{
  "score": {
    "trustScore": 3.9,
    "stars": 4
  },
  "numberOfReviews": 33,
  "profileUrl": "https://www.trustpilot.com/review/saferyou.de",
  "reviews": {
    "de": [
      {
        "id": "698e19ae6de545e8f443ab86",
        "stars": 3,
        "title": "Gutes Produkt, schwierige Regulierung im Ernstfall",
        "text": "Die Vermittlung des web@ktiv Premium-Tarifs verlief reibungslos und die Vertragsinhalte (z. B. Sonderbedingung 12b) passen ideal zu meiner Nebentätigkeit. Leider zeigt sich die Versicherung (ARAG) im ersten Ernstfall trotz klarer Nachweise sehr unkooperativ, was eine Vorstandsbeschwerde und ein Schlichtungsverfahren nötig machte. Hier hätte ich mir mehr Unterstützung durch SaferYou als Vermittler gewünscht.",
        "consumer": "M. Dirksen",
        "createdAt": "2026-02-12T20:19:26Z",
        "isVerified": false
      },
      {
        "id": "6980a97459d617561c701beb",
        "stars": 5,
        "title": "Super Versicherung",
        "text": "Super Versicherung ",
        "consumer": "Undine",
        "createdAt": "2026-02-02T15:41:08Z",
        "isVerified": false
      },
      {
        "id": "68dcfbe3ae5946703f29b51a",
        "stars": 1,
        "title": "Hallo und guten Tag!",
        "text": "Hallo und guten Tag!\n\nIch habe die Versicherung zum Schutz abgeschlossen! Die ARAG hat mir auch bereits Ungerlahen zukommen lassen ! Wo kann ich die App herunterladen?",
        "consumer": "Sabine Mechelhoff",
        "createdAt": "2025-10-01T12:01:07Z",
        "isVerified": false
      },
      {
        "id": "68d41fc3772941218d746113",
        "stars": 5,
        "title": "Klaus Decker ",
        "text": "Ich bin komplett zufrieden mit Saferyou ",
        "consumer": "Klaus Decker",
        "createdAt": "2025-09-24T18:43:47Z",
        "isVerified": false
      },
      {
        "id": "68cab016d7693e30931bb5bf",
        "stars": 5,
        "title": "Einfache Antragsstellung.",
        "text": "Einfache Antragsstellung.",
        "consumer": "Markus Freiberger",
        "createdAt": "2025-09-17T14:56:54Z",
        "isVerified": false
      },
      {
        "id": "68bc871de0ec6fd228c9f158",
        "stars": 5,
        "title": "Lingemann ",
        "text": "Ich muss es erst austesten",
        "consumer": "Sarah Lingemann",
        "createdAt": "2025-09-06T21:10:21Z",
        "isVerified": false
      },
      {
        "id": "68b20f7cf106f145485f0e2c",
        "stars": 5,
        "title": "Bin neu und gespannt ",
        "text": "Bin neu und geap",
        "consumer": "Frank Müller",
        "createdAt": "2025-08-29T22:37:16Z",
        "isVerified": false
      },
      {
        "id": "68aae6a2beec3599442fdba9",
        "stars": 5,
        "title": "kann ich noch nicht",
        "text": "kann ich noch nicht",
        "consumer": "Gerhard Buhleier",
        "createdAt": "2025-08-24T12:17:06Z",
        "isVerified": true
      },
      {
        "id": "68a480b7f42ce3a4e1490eaf",
        "stars": 5,
        "title": "Thomas",
        "text": "Ich finde Ihren unternehm gut sehr hilfsbereit und würde mich freuen wenn das klappt mit meinem Kredit ",
        "consumer": "Ute Thomas",
        "createdAt": "2025-08-19T15:48:39Z",
        "isVerified": true
      },
      {
        "id": "68a24bc6ea957c8d4649d857",
        "stars": 1,
        "title": "Ich würde ja darüber nachdenken",
        "text": "Ich würde ja darüber nachdenken, etwas abzuschließen, wenn da nicht diese nervige Werbung wäre. Egal was ich streame, immer in der Werbepause kommt diese nervige Werbung. Also mich schreckt es eher ab als das mich das motiviert bei euch was abzuschließen. Never ever.",
        "consumer": "Mario Hünerasky",
        "createdAt": "2025-08-17T23:38:14Z",
        "isVerified": false
      },
      {
        "id": "68a1e638900a6d482c5bcebb",
        "stars": 4,
        "title": "Zu den Leistungen kann ich noch nichts…",
        "text": "Zu den Leistungen kann ich noch nichts sagen das Online anmelden war wie immer ein klacks ",
        "consumer": "Udo Braun",
        "createdAt": "2025-08-17T16:24:56Z",
        "isVerified": false
      },
      {
        "id": "6899f6ac9124b6a5fcdb1f15",
        "stars": 4,
        "title": "Bautzmann ",
        "text": "Sehr gut ??!!::..\"\"",
        "consumer": "Jana Bautzmann",
        "createdAt": "2025-08-11T15:57:00Z",
        "isVerified": false
      },
      {
        "id": "685807fc3cb98b279cf361d0",
        "stars": 5,
        "title": "War gut",
        "text": "War gut! hatte nur eine Frage bei einer Rechtsberaterin.\nwollte mich über meine Rechtslagen informieren und beraten lassen. Somit bekam Ich eine Antwort. Und die bestätigte mir schon mal positive Ergebnisse.\n",
        "consumer": "Savas Köroglu",
        "createdAt": "2025-06-22T15:41:16Z",
        "isVerified": false
      },
      {
        "id": "684b62995f7030f0defe6c54",
        "stars": 5,
        "title": "genial",
        "text": "genial, war anfangs überrascht und von dem Service sehr überzeugt!",
        "consumer": "Savas Köroglu",
        "createdAt": "2025-06-13T01:28:25Z",
        "isVerified": false
      },
      {
        "id": "68453dba1b2ea207b8bb383a",
        "stars": 5,
        "title": "War eine super Erfahrung war eine erfrischend neue und super Erfahrung",
        "text": "War eine super Erfahrung. Es ging intuitiv und war nicht mit so vielen Versicherungssoezifischen Termini behaftet. Die drei Produkte waren übersichtlich dargestellt und erklärt. Bin wirklich sehr positiv überrascht",
        "consumer": "Andreas Bernitt",
        "createdAt": "2025-06-08T09:37:30Z",
        "isVerified": false
      }
    ],
    "en": []
  },
  "lastUpdatedAt": "2026-07-09T08:42:57.629Z"
}